import { useCallback, useState } from "react";
import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseDropdown from "../../components/ui/BaseDropdown";
import { RadioGroup, Tooltip } from "@mui/material";
import BaseTextField from "../../components/ui/BaseTextField";
import TuneIcon from "@mui/icons-material/Tune";
import FindJobFilters from "./FindJobFilters";
import BaseButton from "../../components/ui/BaseButton";
import SearchLocation from "../../components/SearchLocation/SearchLocation";
import BaseRadio from "../../components/ui/BaseRadio";
import BaseRange from "../../components/ui/BaseRange";

const FindJobListingHeader = ({
  handleRadiusChange,
  handleLocationSearch,
  handleSearchChange,
  isWorkOrderLoading,
  fetchJobs,
  fetchFreelancerJobsMutation,
  appliedFilters,
  removeFilter,
  currentStatus,
  reFetchJobsCount,
  radius,
  selectedLocation,
  search,
  setFiltersChanged,
  isCompanyMember,
}) => {
  const [isConverageArea, setIsConverageArea] = useState(false);
  const [isTypesOfJob, setIsTypesOfJob] = useState(false);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const hasAppliedFilters = appliedFilters.length > 0;
  const handleClickTypesOfJob = useCallback(() => {
    setIsTypesOfJob((prev) => !prev);
  }, []);

  const handleClickCoverageArea = useCallback(() => {
    setIsConverageArea((prev) => !prev);
  }, []);

  const handleApplyButton = () => {
    reFetchJobsCount();
    fetchJobs();
    setIsConverageArea(false);
  };

  return (
    <BaseWrapper>
      <div className="bg-white rounded-lg shadow-md">
        <div className="grid grid-cols-12 p-3 items-center ">
          <div className="flex lg:col-span-9 col-span-12 grid grid-cols-12 gap-x-6 gap-y-3">
            {!isCompanyMember && <div
              className="2xl:col-span-4 xl:col-span-4 lg:col-span-4 col-span-12 bg-[#EAF1FF] rounded-md p-2 flex items-center justify-center relative cursor-pointer"
              onClick={handleClickCoverageArea}
            >
              <i className="fa-solid fa-location-dot text-primary"></i>
              <p className="text-primary text-sm  mx-3">Coverage Area ({radius} Km)</p>
              <i className="fa-solid fa-caret-down text-primary"></i>
              <BaseDropdown
                closeOnOutsideClick={false}
                setOpen={setIsConverageArea}
                open={isConverageArea}
                className="w-[416px] top-[50px] shadow-none"
                style={{ boxShadow: "0 1px 10px rgba(0, 0, 0, 0.2)" }}
              >
                <div className="p-3">
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="HOURLY"
                    name="radio-buttons-group"
                  >
                    <BaseRadio
                      label="On Site Job"
                      value="HOURLY"
                      name="payType"
                      // onChange={handleChange}
                    />
                    <div className="mb-6">
                      <SearchLocation
                        label=""
                        onPlaceSelected={handleLocationSearch}
                        defaultValue={selectedLocation}
                      />
                      <p className="text-sm font-normal mt-1">Country, City, state or zip</p>
                    </div>

                    <div className="mb-6">
                      <BaseRange
                        min={0}
                        max={500}
                        defaultValue={radius}
                        onChange={(e) => handleRadiusChange(e.target.value)}
                      />
                      <p className="text-sm font-normal">Coverage Area ({radius} km)</p>
                    </div>

                    {/* <BaseRadio
                      label="Remote Work"
                      value="REMOTE"
                      name="payType"
                      // onChange={handleChange}
                    /> */}
                  </RadioGroup>
                </div>
                <div className="flex justify-center mt-3 mb-6">
                  <BaseButton
                    className="bg-[#E5E5E5] text-[#8F8F8F] text-xs w-[104px] h-8 font-normal mr-5"
                    onClick={() => setIsConverageArea(false)}
                  >
                    Cancel
                  </BaseButton>
                  <BaseButton
                    className="text-xs w-[104px] h-8 font-normal"
                    onClick={handleApplyButton}
                  >
                    Apply
                  </BaseButton>
                </div>
              </BaseDropdown>
            </div>}
            <div className="col-span-12 lg:col-span-8 overflow-x-auto whitespace-nowrap py-1 scrollbar ">
              <div className="flex gap-2 ">
                {appliedFilters.map((f) => (
                  <div
                    key={(f.key || "") + (f.value || "") + (f.id || "")}
                    className="flex-shrink-0 flex items-center bg-[#EAF1FF] text-sm font-medium rounded-md px-3 py-1"
                  >
                    <span className="text-primary">{f.prefix}:</span>&nbsp;
                    <p className="text-primary text-sm  mx-1">{f.value}</p>
                    <button
                      onClick={() => removeFilter(f.key, f.id)}
                      className="ml-2 text-primary hover:text-red-500"
                      aria-label={`Remove ${f.prefix} ${f.value}`}
                    >
                      <i className="fas fa-times text-xs"></i>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3 flex items-center justify-end mt-3 lg:mt-0 gap-2">
            <Tooltip title="Filters" arrow>
              <button
                onClick={() => setIsFilterDrawerOpen(true)}
                className={`p-2 rounded-md transition-colors ${
                  hasAppliedFilters ? "bg-[#EAF1FF]" : "bg-transparent hover:bg-gray-100"
                }`}
              >
                <TuneIcon className={`${hasAppliedFilters ? "text-primary" : "text-black"}`} />
              </button>
            </Tooltip>

            <BaseTextField
              placeholder="Search by WO title or reference ID"
              onChange={(e) => handleSearchChange(e.target.value)}
              value={search}
              startAdornment={<i className="fa-light fa-magnifying-glass text-lg text-gray-500" />}
              className="w-full lg:w-[300px]"
            />
          </div>

          <div className="lg:col-span-5 hidden sm:block flex  items-center justify-end">
            <div>
              {/*    <BaseButton
                variant="contained"
                color="primary"
                className="pt-2 pb-2"
                //   onClick={handleNewWorkOrder}
              >
                <p className="text-white">Create New Work Order</p>
              </BaseButton> */}
            </div>
          </div>
          <FindJobFilters
            open={isFilterDrawerOpen}
            onClose={() => setIsFilterDrawerOpen(false)}
            fetchJobs={fetchJobs}
            fetchFreelancerJobsMutation={fetchFreelancerJobsMutation}
            currentStatus={currentStatus}
            reFetchJobsCount={reFetchJobsCount}
            isWorkOrderLoading={isWorkOrderLoading}
            setFiltersChanged={setFiltersChanged}
            hasAppliedFilters={hasAppliedFilters}
          />
        </div>
      </div>
    </BaseWrapper>
  );
};

export default FindJobListingHeader;
